import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this shows the signatures of the driver and customer
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <>
            <div className="sign_2_div">
                <div className="row">
                    <div className="col signature_2">
                        <Signature2 heading={"CUSTOMER OR HIS / HER AGENT'S SIGNATURE"}
                                    image={IV1_PageDetails.CustomerSign2.Signature}
                                    date={IV1_PageDetails.CustomerSign2.UpdatedAt} />
                    </div>
                    <div className="col">
                        <Signature2 heading={"DRIVER"} image={IV1_PageDetails.DriverSign2.Signature}
                                    date={IV1_PageDetails.DriverSign2.UpdatedAt} />
                    </div>
                </div>
            </div>
        </>
    )
}

const Signature2 = (props) =>{
    return(
        <>
            <p className="sign_1_headings">{props.heading}</p>
            <br/>
            <img src={props.image} className="img-rounded sign_1_image" alt=""/>
            <br/>
            <p className="sign_1_date"> {props.date}</p>
        </>
    )
}